module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scenetable"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.scenes,
      "empty-text": "No Scenes Found"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "name",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Light Percentage",
      "prop": "percentage",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Power Consumption",
      "prop": "consumption",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type",
      "prop": "scene_type",
      "header-align": "center"
    }
  }), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('el-table-column', {
    attrs: {
      "label": "Operations",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('operations', {
          attrs: {
            "id": props.row.scene_id,
            "disableMore": true
          },
          on: {
            "edit": function($event) {
              _vm.editScene(props.row)
            },
            "delete": _vm.deleteScene
          }
        })]
      }
    }])
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b45756d0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Scenes/SceneTable.vue
// module id = 1041
// module chunks = 5